const initialState = '';

const selectPatientId = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECT_PATIENT_ID': {
            return action.payload;
        }

        case 'CLEAR_SELECT_PATIENT_ID': {
            return '';
        }

        default: {
            return state;
        }
    }
};

export default selectPatientId;
